/* eslint-disable import/prefer-default-export */
import { API } from 'aws-amplify';

export const read = (eventId, hostId) =>
  API.get('eventmanagerPublicApi', `/public/event/${eventId}/host/${hostId}`, { });

// TODO
export const createGuest = (eventId, hostId, guest) =>
  API.put('eventmanagerPublicApi', `/public/event/${eventId}/host/${hostId}/guest`, { body: { guest } });

// TODO
export const addGuests = (eventId, hostId, guests) =>
  API.post('eventmanagerPublicApi', `/public/event/${eventId}/host/${hostId}/guest`, { body: { guests } });

// TODO
export const removeGuest = (eventId, hostId, guestId) =>
  API.del('eventmanagerPublicApi', `/public/event/${eventId}/host/${hostId}/guest/${guestId}`, { });
